module.exports = __webpack_public_path__ + "media/assets/images/btn_create_work-3167f029238e73131086760bb65c6536.svg";